var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang"},[_c('van-field',{attrs:{"required":"","label":"资产编号","label-width":"110","right-icon":"scan","placeholder":"扫码或手动输入资产编号"},on:{"click-right-icon":_vm.onScan,"blur":_vm.inputFinish},model:{value:(_vm.assetNum),callback:function ($$v) {_vm.assetNum=$$v},expression:"assetNum"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }